import { helper } from '@ember/component/helper';

export default helper(function norHelper(params) {
  let v;
  return params.every(p => v = !p) ? true : v;
});
